import { useNetworkStatus } from "@/hooks/useNetworkStatus";
import { WifiOff } from "lucide-react";

/**
 * Shows a persistent banner when the user is offline so they know they're
 * seeing cached data and writes may queue until back online (Zambia connectivity).
 */
export function OfflineBanner() {
  const { isOnline } = useNetworkStatus();

  if (isOnline) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex items-center gap-2 px-4 py-2 bg-amber-500/15 border-b border-amber-500/30 text-amber-800 dark:text-amber-200 dark:bg-amber-500/10"
    >
      <WifiOff className="h-4 w-4 shrink-0" aria-hidden />
      <p className="text-sm font-medium">
        No internet connection. Your recent info is still here. Any new sales or expenses will be saved when you're back online.
      </p>
    </div>
  );
}
